import type { Die, GameState, Reward } from '../types';
import type { Rng } from './rng';

let dieCounter = 0;
export function newDieId(): string {
  return `die_${++dieCounter}_${Math.random().toString(36).slice(2, 7)}`;
}

export function createDie(
  color: Die['color'],
  faces: Die['faces'] = 6
): Die {
  return { id: newDieId(), color, faces, value: null };
}

export function applyReward(state: GameState, reward: Reward, _rng: Rng): GameState {
  switch (reward.kind) {
    case 'addDie': {
      const newDie = createDie(reward.die.color, reward.die.faces);
      return { ...state, bag: [...state.bag, newDie] };
    }
    case 'token': {
      const tokens = { ...state.tokens };
      tokens[reward.token] = (tokens[reward.token] ?? 0) + 1;
      return { ...state, tokens };
    }
  }
}

export function applyRewards(
  state: GameState,
  rewards: Reward[],
  rng: Rng
): GameState {
  let s = state;
  for (const r of rewards) s = applyReward(s, r, rng);
  return s;
}
